import React, { useState } from 'react';
import SubScoreModal from 'global/components/SubScoreModal';
import Image from 'global/components/image';
import { Text } from 'global/components/text';
import { Button } from 'global/components/Button';
import { Collapse, Icon } from '@mui/material';
import { get, size, first } from 'global/lib/lodash';
import { AUTOTAG } from '../index';
import { Row } from '../../../../global/components/row';
import { GridItem, GridText, FlexRow } from './SubScoreLauncher.styles';

export const SubScoreCollapse = (props) => {
  const { pssvCheckpoint, realm } = props;

  const [state, setState] = useState({
    showObs: false,
  });

  const manualSubs = get(pssvCheckpoint, 'subscores', []).filter((ss) => get(ss, 'notes') !== AUTOTAG);
  const autoSubs = get(pssvCheckpoint, 'subscores', []).filter((ss) => get(ss, 'notes') === AUTOTAG || (!get(ss, 'notes') && size(get(ss, 'images', [])) === 0));
  const autoSubsLabel = autoSubs.reduce((agg, i) => {
    const itemName = get(i, 'realm.name');
    return !!itemName ? (!!agg ? `${agg}, ${itemName}` : itemName) : agg;
  }, '');

  return (
    <div>
      {size(autoSubs) > 0 && (
        <Row>
          <Text type="label_medium" bold>{`✔: ${autoSubsLabel}`}</Text>
        </Row>
      )}
      {size(manualSubs) > 0 && (
        <>
          <Row>
            <Text type="label_medium" bold>{`${size(manualSubs)} Instance(s)`}</Text>
            <ShowHideToggle isShow={state.showObs} onClick={() => setState((s) => ({ ...s, showObs: !s.showObs }))} />
          </Row>
          <Collapse in={state.showObs}>
            <SubScoreGrid {...props} realm={realm} pssvCheckpoint={{ ...pssvCheckpoint, subscores: manualSubs }} />
          </Collapse>
        </>
      )}
    </div>
  );
};

const SubScoreGrid = (props) => {
  const { pssvCheckpoint } = props;
  const { subscores } = pssvCheckpoint;
  const [selectedSubScore, setSelectedSubScore] = useState(null);
  const [modal, setModal] = useState({
    open: false,
    onClose: () => {
      setModal((s) => ({ ...s, open: false }));
      props.onRightPanelClose?.();
    },
  });

  const canEdit = get(props, 'canEdit', false);

  const onCheckpointSubscoreClicked = (key, selectedSubScore) => {
    if (canEdit) {
      const pssvTag = {
        pssvSubScore: selectedSubScore,
        pssvCheckpoint: pssvCheckpoint,
        pssvChecklist: props.pssvChecklist,
        pssvSystem: props.pssvSystem,
        isEditMode: true,
      };

      setSelectedSubScore(selectedSubScore);
      props.setHighlightedElement?.(`${get(props, 'realm.id', '')}_${get(selectedSubScore, 'checkpointId')}_${get(selectedSubScore, 'updatedAt')}_subscore_${key}`);

      if (props.onNavigateRight) {
        props.setPssvTag && props.setPssvTag(pssvTag);
        props.onNavigateRight && props.onNavigateRight();
      } else {
        setModal((p) => ({ ...p, open: true }));
      }
    }
  };

  const renderItem = (checkpointSubscoreItem, i) => {
    const image = first(get(checkpointSubscoreItem, 'images', []));

    const dims = { width: 120, height: 120, cursor: canEdit ? 'pointer' : 'default' };

    const currentKey = `${get(props, 'realm.id', '')}_${get(checkpointSubscoreItem, 'checkpointId')}_${get(checkpointSubscoreItem, 'updatedAt')}_subscore_${i}`;
    return (
      <GridItem
        key={currentKey}
        isHighlighted={props.highlightedElement === currentKey}
        style={dims}
        onClick={() => onCheckpointSubscoreClicked(i, checkpointSubscoreItem)}
      >
        {!!image && (
          <div>
            <Image autosize={0} src={get(image, 'thumbUrl')} {...dims} />
          </div>
        )}
        <GridText as={Row}>
          <Text type="label_medium">
            <b>{`${get(checkpointSubscoreItem, 'realm.name', '')}`}</b>
            {`: ${get(checkpointSubscoreItem, 'notes', '')}`}
          </Text>
        </GridText>
      </GridItem>
    );
  };

  return (
    <>
      <FlexRow>{subscores.map(renderItem)} </FlexRow>
      <SubScoreModal
        {...props}
        {...modal}
        scorecard={props.scorecard}
        isDialog={true}
        isDirty={props.isDirty}
        setIsDirty={props.setIsDirty}
        pssvTag={{
          pssvSubScore: selectedSubScore,
          pssvCheckpoint: pssvCheckpoint,
          pssvChecklist: props.pssvChecklist,
          pssvSystem: props.pssvSystem,
          isEditMode: true,
        }}
        realm={selectedSubScore?.realm}
      />
    </>
  );
};

const ShowHideToggle = (props) => {
  const { isShow, onClick } = props;
  return <Button onClick={onClick} variant="text" color="secondary" title={isShow ? 'hide' : 'show'} endIcon={!isShow ? <Icon>arrow_right</Icon> : <Icon>arrow_drop_down</Icon>} />;
};

export default SubScoreCollapse;
